/* eslint-disable import/no-unresolved */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';

import { breakpoints } from 'TMConstants';
import styled from 'styled-components';
import reviewsGetter from 'TMUtils/reviewsGetter';
import Container from 'TMComponents/Container';
import TPStars from 'TMComponents/Icons/TPStars';
import useEmblaCarousel from 'embla-carousel-react';

const Embla = styled.section`
    overflow: hidden;
    margin: auto;
    --slide-height: auto;
    --slide-spacing: 1rem;
    --slide-size: 95%;
`;

const EmblaViewport = styled.div`
    padding: 0 10px;
    overflow: hidden;
`;

const EmblaContainer = styled.div`
    backface-visibility: hidden;
    display: flex;
    align-items: stretch;
    touch-action: pan-y pinch-zoom;
    margin-left: calc(var(--slide-spacing) * -1);
    margin-left: -10px;
    padding: 3px;
`;

const EmblaSlide = styled.div`
    min-width: 0;
    padding-left: 10px;

    flex: 0 0 85%;
    @media (min-width: ${breakpoints.mobileTablet}px) {
        flex: 0 0 33%;
    }

    &:first-child {
        padding-left: 0px;
    }
`;

const EmblaSlideNumber = styled.div`
    box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    user-select: none;
`;

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-top: 25px;
    background-color: ${({ theme }) => theme.colorSystem.primary[3]};
    border-radius: 25px / 25px;
    border-bottom-left-radius: 0px;
    border: 2px solid ${({ theme }) => theme.colorSystem.UIElements[4]};
    margin: 0 -16px;
`;

const ContainerPadding = {
    padding: '24px 0'
};

const ContentPadding = styled.div`
    padding: 20px;
`;

const TrustpilotCarousel = () => {
    const [reviews, setReviews] = useState([]);

    // Fix for weird carousel jump issue
    useEffect(() => {
        const fetchReviews = async () => {
            const data = await reviewsGetter(5);
            setReviews(data);
        };
        fetchReviews();
    }, []);

    const [emblaRef] = useEmblaCarousel({
        loop: false
    });

    return (
        <Container style={ContainerPadding} size="medium">
            <Embla>
                <EmblaViewport ref={emblaRef} data-testid="embla-viewport">
                    <EmblaContainer>
                        {reviews.map(({ id, text, stars }) => (
                            <EmblaSlide key={id}>
                                <EmblaSlideNumber>
                                    <Wrapper>
                                        <ContentPadding>
                                            <TPStars rating={stars} />
                                            <p>&quot;{text}&quot;</p>
                                        </ContentPadding>
                                    </Wrapper>
                                </EmblaSlideNumber>
                            </EmblaSlide>
                        ))}
                    </EmblaContainer>
                </EmblaViewport>
            </Embla>
        </Container>
    );
};

export default TrustpilotCarousel;
